// core/lib/onboardingDeferral.ts — "Remind me later" for the first-run flow
// (1.24.00 B1), stored per tab and never persisted.
//
// This lives in core/ rather than beside the rest of the onboarding feature for
// one reason: authService.signOut() has to forget the deferral, and core/ must
// never import from features/ (components -> hooks -> core/services -> core/lib
// is the seam this project keeps). features/onboarding/onboardingGate.ts re-
// exports these so feature code can keep importing from one place.
//
// Completion itself is NOT stored here — it lives on the server as
// `user.onboardedAt`, which is what makes the flow resumable across devices.
// This key only hides the flow for the rest of the current tab's session.

export const ONBOARDING_DEFER_KEY = 'trux:onboarding-deferred';

export function isOnboardingDeferred(): boolean {
  try {
    return sessionStorage.getItem(ONBOARDING_DEFER_KEY) === '1';
  } catch {
    return false;
  }
}

/** "Remind me later" — hide the flow for the rest of this tab's session only. */
export function deferOnboarding(): void {
  try {
    sessionStorage.setItem(ONBOARDING_DEFER_KEY, '1');
  } catch {
    /* private mode / storage disabled — the redirect simply keeps firing */
  }
}

/** Sign-out / test hygiene: forget a deferral so the next account is judged fresh. */
export function clearOnboardingDeferral(): void {
  try {
    sessionStorage.removeItem(ONBOARDING_DEFER_KEY);
  } catch {
    /* ignore */
  }
}
